export function getCurrency(state) {
    return state.currency;
}
